import { getBond, addAtom, addBond, editBond } from '@moleculeone/draw';
import { V4 } from '@moleculeone/utils';

import { updateMols, updateState } from '../../../state';
import { DEFAULT_MODE, MOL_MOUSE_EVENT, MOUSE_DOWN, MOUSE_MOVE, MOUSE_UP } from '../../../../etc/constants';

import { rankedCandidates } from './positionCandidates';

function effect(state, action) {
  if (action.type !== MOL_MOUSE_EVENT) {
    return {};
  }
  return baseEffect(state.mols, state.mode, action.event, state.mouse.molIndex);
}

function baseEffect(mols, mode, event, molIndex) {
  if (event.type === MOUSE_MOVE) {
    return {};
  }

  const data = mode.data;
  let newMol = mols[molIndex];
  let newData = initial.data;

  if (event.type === MOUSE_DOWN && data != null) {
    //
  } else if (event.type === MOUSE_UP && data == null) {
    //
  } else if (event.type === MOUSE_DOWN && data == null) {
    if (event.bond) {
      newMol = editBond(newMol, event.idx, (newMol.bonds[event.idx].order % 3) + 1);
    } else if (event.empty) {
      let newAtom;
      [newMol, newAtom] = addAtom(newMol, event.svgPos);
      newData = { idx: newAtom.idx, newAtom: true, clientPos: event.clientPos };
    } else if (event.atom) {
      newData = { idx: event.idx, newAtom: false, clientPos: event.clientPos };
    }
  } else if (event.type === MOUSE_UP && data != null) {
    if (data.newAtom === false || V4.dist(event.clientPos, data.clientPos) >= 25) {
      const startIdx = data.idx;
      let newAtom;
      if (event.empty) {
        const dirvect = V4.sub(event.svgPos, newMol.positions[startIdx]);
        const newPos = V4.add(newMol.positions[startIdx], V4.normal(dirvect, 100));
        [newMol, newAtom] = addAtom(newMol, newPos);
        [newMol] = addBond(newMol, startIdx, newAtom.idx);
      } else if (event.atom && event.idx !== startIdx) {
        if (getBond(newMol, event.idx, startIdx) == null) {
          [newMol] = addBond(newMol, startIdx, event.idx);
        }
      } else if (event.atom && event.idx === startIdx) {
        const newPosition = rankedCandidates(newMol, startIdx)[0];
        [newMol, newAtom] = addAtom(newMol, newPosition);
        [newMol] = addBond(newMol, startIdx, newAtom.idx);
      }
    }
  }
  return {
    mols: updateMols(mols, newMol, molIndex),
    mode: updateState(mode, { data: newData }),
  };
}

function preview(state) {
  const { lastMove, molIndex } = state.mouse;
  if (state.mode.data == null && lastMove != null && lastMove.atom) {
    const mouseDownEvent = updateState(lastMove, { type: MOUSE_DOWN });
    const mouseDownPreviewState = baseEffect(state.mols, state.mode, mouseDownEvent, molIndex);
    const mouseUpEvent = updateState(lastMove, { type: MOUSE_UP });
    const mouseUpPreviewState = baseEffect(
      mouseDownPreviewState.mols,
      mouseDownPreviewState.mode,
      mouseUpEvent,
      molIndex
    );
    const previewMol = mouseUpPreviewState.mols[molIndex];

    if (previewMol != null && previewMol !== state.mols[molIndex]) {
      const editedBonds = {};
      for (const [key, bond] of Object.entries(previewMol.bonds)) {
        if (state.mols[molIndex].bonds[key] == null) {
          editedBonds[key] = { ...bond, preview: true };
        }
      }
      return updateState(previewMol, { bonds: updateState(previewMol.bonds, editedBonds) });
    }
  } else if (state.mode.data != null && lastMove != null) {
    const mouseUpEvent = updateState(lastMove, { type: MOUSE_UP });
    const previewState = baseEffect(state.mols, state.mode, mouseUpEvent, molIndex);
    const previewMol = previewState.mols[molIndex];
    if (previewMol != null && previewMol !== state.mols[molIndex]) {
      const editedBonds = {};
      for (const [key, bond] of Object.entries(previewMol.bonds)) {
        if (state.mols[molIndex].bonds[key] !== bond) {
          editedBonds[key] = { ...bond, preview: true };
        }
      }
      return updateState(previewMol, { bonds: updateState(previewMol.bonds, editedBonds) });
    }
  }
  return null;
}

function cleanup(mode, mol) {
  if (mode.data != null && mol.atoms[mode.data.idx] == null) {
    return initial;
  }
  return mode;
}

const initial = {
  type: DEFAULT_MODE,
  data: null,
};

export const trait = {
  type: DEFAULT_MODE,
  initial,
  effect,
  preview,
  cleanup,
};
